module.exports = __webpack_public_path__ + "static/img/T.d7bf06b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ssxxg/T.png
// module id = un6k
// module chunks = 0